const CACHE_PREFIX = "ipaddi:list-cache:"
const DEFAULT_TTL_MS = 1000 * 60 * 60 * 24

type CacheEntry<T> = {
  savedAt: number
  data: T
}

const cacheKey = (key: string) => `${CACHE_PREFIX}${key}`

export const readListCache = <T>(key: string, ttlMs = DEFAULT_TTL_MS): T | null => {
  try {
    const raw = localStorage.getItem(cacheKey(key))
    if (!raw) {
      return null
    }
    const entry = JSON.parse(raw) as CacheEntry<T>
    if (!entry.savedAt || Date.now() - entry.savedAt > ttlMs) {
      localStorage.removeItem(cacheKey(key))
      return null
    }
    return entry.data
  } catch (error) {
    // Cache rotta? La butemo via e avanti col server.
    localStorage.removeItem(cacheKey(key))
    return null
  }
}

export const writeListCache = <T>(key: string, data: T) => {
  try {
    const entry: CacheEntry<T> = {
      savedAt: Date.now(),
      data,
    }
    localStorage.setItem(cacheKey(key), JSON.stringify(entry))
  } catch (error) {
    // Se Safari/iOS taglia lo storage non deve rompere l'app.
    console.warn("Unable to write list cache", key, error)
  }
}
